__webpack_require__.p = "/React-mini-projects/curd-live/";